import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Achievements from './components/Achievements';
import Certificates from './components/Certificates';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ResumeViewer from './components/ResumeViewer';
import { Toaster } from './components/ui/toaster';
import WhatsAppToggle from './components/WhatsAppToggle';

function HomePage({ initialSection }) {
  useEffect(() => {
    if (!initialSection) {
      window.scrollTo({ top: 0, behavior: 'auto' });
      return;
    }

    const scrollToSection = () => {
      const element = document.querySelector(initialSection);
      if (!element) return;

      const navOffset = 72;
      const top = element.getBoundingClientRect().top + window.scrollY - navOffset;
      window.scrollTo({ top, behavior: 'auto' });
    };

    const firstFrame = window.requestAnimationFrame(() => {
      scrollToSection();
      window.setTimeout(scrollToSection, 150);
    });

    return () => window.cancelAnimationFrame(firstFrame);
  }, [initialSection]);

  return (
    <div className="bg-gray-900">
      <Navbar />
      <Hero />
      <About />
      <Experience />
      <Projects />
      <Achievements />
      <Certificates />
      <Contact />
      <Footer />
      <Toaster />
      <WhatsAppToggle />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<HomePage initialSection="#about" />} />
        <Route path="/experience" element={<HomePage initialSection="#experience" />} />
        <Route path="/projects" element={<HomePage initialSection="#projects" />} />
        <Route path="/achievements" element={<HomePage initialSection="#achievements" />} />
        <Route path="/certificates" element={<HomePage initialSection="#certificates" />} />
        <Route path="/contact" element={<HomePage initialSection="#contact" />} />
        <Route path="/resume" element={<ResumeViewer />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
